module.exports = __webpack_public_path__ + "img/fond_cron_manager.b99ac15e.jpg";